const config = {
  apiBaseUrl: process.env.REACT_APP_API_BASE_URL || "https://ibottomline.api.classicinformatics.net/api",
  assetsBaseUrl: process.env.REACT_APP_ASSETS_BASE_URL || "https://ibottomline.api.classicinformatics.net",
  appName: process.env.REACT_APP_NAME || "iBottomLine",
  environment: process.env.REACT_APP_NODE_ENV || "production", // development / production
  /** Same-origin manifest URL path when not using pwaManifestApiPath (multi-tenant hosts should proxy this to the API). */
  pwaManifestPath: process.env.REACT_APP_PWA_MANIFEST_PATH || "/web-app-manifest.json",
  /** If set (e.g. /auth/web-manifest), manifest is loaded from apiBaseUrl + this path (requires CORS from tenant origins). */
  pwaManifestApiPath: process.env.REACT_APP_PWA_MANIFEST_API_PATH || "",
  /**
   * Milliseconds with no activity before showing the idle warning (default 58 minutes for Production).
   * @see src/components/session/IdleSessionWatcher.js
   */
  idlePromptAfterMs: Math.max(
    1000,
    Number(process.env.REACT_APP_IDLE_PROMPT_AFTER_MS) || 58 * 60 * 1000
  ),
  /**
   * Milliseconds after the warning appears before automatic sign-out (default 2 minutes).
   */
  idlePromptGraceMs: Math.max(
    1000,
    Number(process.env.REACT_APP_IDLE_PROMPT_GRACE_MS) || 2 * 60 * 1000
  ),
  /**
   * Same as idlePromptAfterMs but for guest ("G") demo sessions specifically
   * — deliberately much shorter than the 58-minute default for real accounts
   * (default 10 minutes), and well under the backend's own ~30-minute demo
   * cleanup cycle so the frontend idle timeout always fires first and the
   * guest sees the friendly /demo-ended screen instead of the session dying
   * underneath them. @see src/layouts/AppLayout.js
   */
  guestIdlePromptAfterMs: Math.max(
    1000,
    Number(process.env.REACT_APP_GUEST_IDLE_PROMPT_AFTER_MS) || 10 * 60 * 1000
  ),
  /**
   * Grace period after the guest idle warning before automatic sign-out (default 1 minute).
   */
  guestIdlePromptGraceMs: Math.max(
    1000,
    Number(process.env.REACT_APP_GUEST_IDLE_PROMPT_GRACE_MS) || 1 * 60 * 1000
  ),
  /**
   * How often (ms) to poll build/asset-manifest.json for a newer deployed build
   * while a tab is already open (default 15 minutes).
   * @see src/hooks/useBuildVersionWatcher.js
   */
  buildVersionCheckIntervalMs: Math.max(
    30 * 1000,
    Number(process.env.REACT_APP_BUILD_VERSION_CHECK_INTERVAL_MS) || 15 * 60 * 1000
  ),
};

export default config;
